import React, { Fragment, useState } from 'react'
import Select from 'react-select'

const Filter = function({ selected, config }) {

  if (config.collection) {
    console.log(config.collection)
    return (
      <div className='row mt-3'>
        <div className='col-2 fw-bold text-right'>{selected.label}</div>
        <div className='col-2 d-flex align-tiems-center justify-content-end'>Filters:</div>
        <div className='col-8'>
          <select name={`organization_data_export[data][${selected.value}]`} className='form-control' defaultValue={selected.filter}>
            <option></option>
            {Object.entries(config.collection).map((item, idx) => <option key={idx} value={item[1]}>{item[0]}</option> )}
          </select>
        </div>
      </div>
    )
  } else if(config.ransack_filter) {
    return (
      <div className='row mt-3'>
        <div className='col-2 fw-bold text-right'>{selected.label}</div>
        <div className='col-2 d-flex align-tiems-center justify-content-end'>Filters:</div>
        <div className='col-8'>
          <input name={`organization_data_export[data][${selected.value}]`} className='form-control' defaultValue={selected.filter} />
        </div>
      </div>
    )
  } else {
    return (
      <div className='row mt-3'>
        <div className='col-2 fw-bold text-right'>{selected.label}</div>
        <div className='col-10 text-center'>
          No Filters
          <input name={`organization_data_export[data][${selected.value}]`} className='d-none' />
        </div>
      </div>
    )
  }

}

export default function DataExport({ options, selectedValues }) {
  const [selected, setSelected] = useState(selectedValues)

  return (
    <Fragment>
      <label>Pick the fields you want to see</label>
      <Select
        value={selected}
        options={options}
        onChange={values => setSelected(values)}
        isMulti
      />

      { selected.map((item, idx) => (<Filter key={idx} selected={item} config={options.filter((o) => o.value === item.value)[0]} />)) }
    </Fragment>
  )
}
